import { QueryResult } from '@apollo/client';
import * as React from 'react';
import { TransactionAccount, Maybe, FetchTransactionAccountQuery } from '@css-xp/graphtypes';
import {
  FetchTransactionAccountForEntitlementQuery,
  EntitlementTermDetails,
} from '@css-xp/graphtypes/src/generated-types-new';

export const getTransactionAccount = (queryData: FetchTransactionAccountForEntitlementQuery) => {
  return queryData?.entitlementDetails?.transactionAccount as TransactionAccount;
};

export const getCreditDetails = (queryData: FetchTransactionAccountForEntitlementQuery) => {
  return queryData?.entitlementDetails?.termDetails as EntitlementTermDetails;
};

export type TransactionAccountContextType = Partial<QueryResult> & {
  getTransactionAccount: (data: FetchTransactionAccountQuery) => Maybe<TransactionAccount>;
  getCreditDetails?: (data: FetchTransactionAccountForEntitlementQuery) => Maybe<EntitlementTermDetails>;
};

export const TransactionAccountContext = React.createContext<TransactionAccountContextType>({
  getTransactionAccount: () => {
    throw new Error('setup getTransactionAccount on the appropriate context provider');
  },
  getCreditDetails: () => {
    throw new Error('setup getTermDetails on the appropriate context provider');
  },
});

// TODO: Make this default
export const useTransactionAccountContext = () => {
  const context = React.useContext(TransactionAccountContext);

  if (!context) {
    throw new Error('context has not been setup');
  }

  return context;
};
